import { FormattedMessage } from 'react-intl'
import { useSearchParams } from 'react-router'

import { getImage } from '@/lib/images'
import { Button, Typography } from '@/shared/ui'

import { ContractorDetails, ContractState } from '../../types'

type Props = {
  contractor?: ContractorDetails
}

export const SignContractTodo = ({ contractor }: Props) => {
  const [, setSearchParams] = useSearchParams()

  const hasAmendedContract = !!contractor?.contracts.find(
    (contract) => contract.state === ContractState.AMENDED,
  )

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap md:gap-0">
        <div className="flex gap-8 md:flex-nowrap md:gap-3">
          <img
            className="hidden w-8 object-contain md:block"
            src={getImage({ name: 'todo-list', category: 'contractors' })}
            alt=""
            aria-hidden
          />

          <div className="flex flex-col justify-center pr-2">
            <Typography bold>
              {hasAmendedContract ? (
                <FormattedMessage
                  id="contractors.toDo.signAmendedContract.title"
                  defaultMessage="Sign the amended contract with {name}"
                  values={{
                    name: contractor?.personalDetails.firstName,
                  }}
                />
              ) : (
                <FormattedMessage
                  id="contractors.toDo.signContract.title"
                  defaultMessage="Review and sign {name}'s contract"
                  values={{
                    name: contractor?.personalDetails.firstName,
                  }}
                />
              )}
            </Typography>
            <Typography variant="body-small" className="text-neutral-gray-600">
              {hasAmendedContract ? (
                <FormattedMessage
                  id="contractors.toDo.signAmendedContract.description"
                  defaultMessage="{name} has already signed their contract, we are just missing your signature to finalize the new contract"
                  values={{
                    name: contractor?.personalDetails.firstName,
                  }}
                />
              ) : (
                <FormattedMessage
                  id="contractors.toDo.signContract.description"
                  defaultMessage="You need to review and sign the contract"
                />
              )}
            </Typography>
          </div>
        </div>

        <Button
          onClick={() => {
            setSearchParams(
              (params) => {
                params.set('sign-contract', 'true')
                return params
              },
              { preventScrollReset: true },
            )
          }}
        >
          <FormattedMessage
            id="actions.reviewAndSign"
            defaultMessage="Review & sign"
          />
        </Button>
      </div>
    </>
  )
}
